// For testing in personal account replace the <<ACCOUNT-ID>> with personal account id
const iamRoleMap: Map<string, string> = new Map([
    ['PROD', 'arn:aws:iam::383811988833:role/ImageGalleryWebIdentityRole'],
    ['BETA', 'arn:aws:iam::670825047321:role/ImageGalleryWebIdentityRole'],
    ['GAMMA', 'arn:aws:iam::381492230458:role/ImageGalleryWebIdentityRole'],
    ['PERSONAL', 'arn:aws:iam::381492230458:role/ImageGalleryWebIdentityRole']
]);

// For testing in personal account replace the <<API-ENDPOINT>> with the endpoint in personal account
const apiEndpointMap: Map<string, string> = new Map([
    ['NA', 'jyo2yddl64.execute-api.us-east-1.amazonaws.com'],
    ['EU', 'e2x2y7wj62.execute-api.eu-west-1.amazonaws.com'],
    ['JP', '8ihzpp2mfi.execute-api.ap-northeast-1.amazonaws.com'],
    ['BETA', '68ycc9pv47.execute-api.us-east-1.amazonaws.com'],
    ['GAMMA', 'h8qizgx9t2.execute-api.us-east-1.amazonaws.com'],
    ['PERSONAL', 'ryrgglf0ma.execute-api.us-east-1.amazonaws.com']
]);

const apiKeyMap: Map<string, string> = new Map([
    ['PROD', 'ImageGalleryUIProdItemMatrixImageGalleryApiKey'],
    ['BETA', 'ImageGalleryUIBetaItemMatrixImageGalleryApiKey'],
    ['GAMMA', 'ImageGalleryUIGammaItemMatrixImageGalleryApiKey'],
    ['PERSONAL', 'ImageGalleryUIGammaItemMatrixImageGalleryApiKey']
]);

function getStageName() {
    const prod: string = 'PROD';
    const beta: string = 'BETA';
    const personal: string = 'PERSONAL';
    const gamma: string = 'GAMMA';
    const origin = window.location.origin;

    if (origin.includes(prod.toLowerCase()))
        return prod;
    else if (origin.includes(beta.toLowerCase()))
        return beta;
    else if (origin.includes(gamma.toLowerCase()))
        return gamma;
    else
        return personal;
}

export function getIamRoleArn() {
    const stage: string = getStageName();
    return iamRoleMap.get(stage);
}

export function getApiEndpoint(region: string) {
    const stage: string = getStageName();
    if (stage === 'PROD')
        return apiEndpointMap.get(region);
    else
        return apiEndpointMap.get(stage);
}

export function getApiKey() {
    const stage: string = getStageName();
    return apiKeyMap.get(stage);
}

